(() => {
  'use strict';
  const T = (k, f) => (window.PW3 && window.PW3.i18n && window.PW3.i18n[k]) || f;
  if (window.__PW9_PRODUCT_READY__) return;
  window.__PW9_PRODUCT_READY__ = true;

  const $ = (selector, root = document) => root?.querySelector(selector) || null;
  const $$ = (selector, root = document) => root ? [...root.querySelectorAll(selector)] : [];
  const mobileQuery = window.matchMedia('(max-width: 900px)');

  const formatMoney = cents => window.PielurdMoney.format(cents);

  const initProduct = root => {
    if (!root || root.dataset.pw9ProductReady === 'true') return;
    root.dataset.pw9ProductReady = 'true';

    const slides = $$('[data-pw4-pdp-slide]', root);
    const dots = $$('[data-pw4-pdp-dot]', root);
    const towerButtons = $$('[data-pw4-pdp-go-to]', root);
    const counters = $$('[data-pw4-pdp-current]', root);
    const stage = $('[data-pw4-pdp-stage]', root);
    const track = $('[data-pw27-gallery-track]', root);
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    if (mobileQuery.matches && slides.length) index = 0;

    const normalize = requested => {
      if (!slides.length) return 0;
      return (Number(requested) + slides.length) % slides.length;
    };

    const show = (requested, { focus = false, scroll = true } = {}) => {
      if (!slides.length) return;
      index = normalize(requested);

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !mobileQuery.matches && !active;
        slide.setAttribute('aria-hidden', String(!mobileQuery.matches && !active));

        const videos = $$('video', slide);
        if (!active) videos.forEach(video => video.pause());
        if (active) {
          const image = $('img', slide);
          if (image) {
            image.loading = 'eager';
            image.decoding = 'async';
            image.decode?.().catch(() => {});
          }
          slide.classList.remove('is-entering');
          requestAnimationFrame(() => slide.classList.add('is-entering'));
        }
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      towerButtons.forEach(button => {
        const active = Number(button.dataset.pw4PdpGoTo || 0) === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      counters.forEach(counter => { counter.textContent = String(index + 1); });
      root.dataset.pw9MediaIndex = String(index);
      root.style.setProperty('--pw9-media-progress', String((index + 1) / Math.max(1, slides.length)));
      if (mobileQuery.matches && track && scroll) track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      if (focus) stage?.focus({ preventScroll: true });
    };

    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
    towerButtons.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.pw4PdpGoTo || 0))));
    $('[data-pw4-pdp-prev]', root)?.addEventListener('click', () => show(index - 1));
    $('[data-pw4-pdp-next]', root)?.addEventListener('click', () => show(index + 1));

    if (stage) {
      stage.setAttribute('aria-roledescription', 'carousel');
      stage.setAttribute('aria-label', $('.pw4-pdp__dots', root)?.getAttribute('aria-label') || '');
      let startX = null;
      let startY = null;
      let startedAt = 0;

      stage.addEventListener('dragstart', event => event.preventDefault());
      stage.addEventListener('pointerdown', event => {
        if (mobileQuery.matches && track) return;
        if (event.pointerType === 'mouse' || event.target.closest('button,a,video[controls]')) return;
        startX = event.clientX;
        startY = event.clientY;
        startedAt = performance.now();
        try { stage.setPointerCapture(event.pointerId); } catch {}
      });
      stage.addEventListener('pointercancel', () => {
        startX = null;
        startY = null;
      });
      stage.addEventListener('pointerup', event => {
        if (startX === null) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        const elapsed = Math.max(1, performance.now() - startedAt);
        const velocity = Math.abs(dx) / elapsed;
        startX = null;
        startY = null;
        if ((Math.abs(dx) > 46 || velocity > .45) && Math.abs(dx) > Math.abs(dy) * 1.08) {
          show(index + (dx < 0 ? 1 : -1));
        }
      });
      stage.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1);
        }
        if (event.key === 'Home') {
          event.preventDefault();
          show(0);
        }
        if (event.key === 'End') {
          event.preventDefault();
          show(slides.length - 1);
        }
      });
    }

    const form = $('[data-pw4-product-form]', root);
    const quantity = $('input[name="quantity"]', form);
    const buyNowQty = $('[data-pw4-buynow-qty]', root);
    const syncBuyNowQty = () => { if (buyNowQty && quantity) buyNowQty.value = quantity.value; };
    $$('[data-pw4-qty]', root).forEach(button => button.addEventListener('click', () => {
      if (!quantity) return;
      const delta = button.dataset.pw4Qty === 'plus' ? 1 : -1;
      quantity.value = String(Math.max(1, Number(quantity.value || 1) + delta));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    quantity?.addEventListener('change', () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1)));
      syncBuyNowQty();
    });
    syncBuyNowQty();

    const variantsNode = $('[data-pw4-variants]', root);
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch {}

    const select = $('[data-pw4-variant-select]', root);
    const hiddenId = $('[data-pw4-variant-id]', root);
    const updateVariant = id => {
      const variant = variants.find(item => String(item.id) === String(id));
      if (!variant) return;

      if (hiddenId) hiddenId.value = variant.id;
      const price = formatMoney(variant.price);
      const available = Boolean(variant.available);

      $$('[data-pw4-product-price],[data-pw4-add-price],[data-pw4-mobile-price]', root)
        .forEach(node => { node.textContent = price; });

      const add = $('.pw4-pdp__add', root);
      const label = $('[data-pw4-add-label]', root);
      const mobile = $('[data-pw4-mobile-add]', root);
      if (add) add.disabled = !available;
      const buyNowId = $('[data-pw4-buynow-id]', root);
      if (buyNowId) buyNowId.value = variant.id;
      const buyNow = $('[data-pw4-buynow]', root);
      if (buyNow) buyNow.disabled = !available;
      if (label) label.textContent = available ? T('add_to_cart', 'SEPETE EKLE') : T('sold_out', 'TÜKENDİ');
      if (mobile) {
        mobile.disabled = !available;
        mobile.textContent = available ? T('add_to_cart', 'SEPETE EKLE') : T('sold_out', 'TÜKENDİ');
      }

      $$('[data-pw4-product-variant]', root).forEach(node => {
        node.dataset.pw4ProductVariant = String(variant.id);
        node.dataset.pw4ProductPrice = price;
        node.dataset.pw4ProductAvailable = String(available);
      });
      $$('[data-pw4-story-card]', root).forEach(card => {
        card.dataset.pw4ProductVariant = String(variant.id);
        card.dataset.pw4ProductPrice = price;
        card.dataset.pw4ProductAvailable = String(available);
      });

      const bundle = $('[data-pw4-bundle-add]', root);
      if (bundle) bundle.dataset.currentVariant = String(variant.id);

      const availability = $('.pw4-pdp__availability', root);
      if (availability) {
        availability.innerHTML = available ? `<i></i> ${T('in_stock_ready', 'STOKTA • GÖNDERİME HAZIR')}` : T('sold_out', 'TÜKENDİ');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    select?.addEventListener('change', () => updateVariant(select.value));

    $('[data-pw4-mobile-add]', root)?.addEventListener('click', () => form?.requestSubmit());
    const mobileBar = $('[data-pw4-mobile-atc]', root);
    if (track) {
      let scrollFrame = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const atEnd = track.scrollLeft > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          const nearest = atEnd ? slides.length - 1 : slides.reduce((best, slide, i) =>
            Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) <
            Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? i : best, 0);
          if (nearest !== index) show(nearest, { scroll: false });
        });
      }, { passive: true });
    }
    mobileQuery.addEventListener('change', () => show(index, { scroll: false }));
    if (mobileBar) {
      // The bottom bar appears only while the main add-to-cart row is off screen.
      const buyRow = $('.pw4-pdp__buy-row', root);
      const canObserve = Boolean(buyRow) && 'IntersectionObserver' in window;
      let buyRowInView = canObserve;
      const updateMobileBar = () => mobileBar.classList.toggle('is-visible', mobileQuery.matches && !buyRowInView);
      if (canObserve) {
        new IntersectionObserver(([entry]) => {
          buyRowInView = entry.isIntersecting;
          updateMobileBar();
        }).observe(buyRow);
      }
      mobileQuery.addEventListener('change', updateMobileBar);
      updateMobileBar();
    }

    $$('.pw4-pdp__accordions details', root).forEach(details => {
      details.addEventListener('toggle', () => {
        const symbol = $('summary span', details);
        if (symbol) symbol.textContent = details.open ? '−' : '+';
      });
    });

    show(index);
  };

  const init = root => $$('[data-pw4-product]', root).forEach(initProduct);

  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
// Videos marked data-pw-lazy-video download and play only when they come near the screen,
// so a visitor who never scrolls that far does not download them.
(() => {
  const videos = document.querySelectorAll('video[data-pw-lazy-video]');
  if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const start = (video) => {
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
    video.play().catch(() => {});
  };
  if (!('IntersectionObserver' in window)) {
    videos.forEach(start);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      start(entry.target);
    });
  }, { rootMargin: '300px 0px' });
  videos.forEach((video) => observer.observe(video));
})();
